import { service } from '../axios';
// 获取分类树
export function getCategoryTree(params) {
    return service({
        url: '/lab/asset-category/tree',
        method: 'get',
        params,
    });
}
// 新增分类
export function createCategory(data) {
    return service({
        url: '/lab/asset-category/add',
        method: 'post',
        data,
    });
}
// 更新分类
export function updateCategory(data) {
    return service({
        url: '/lab/asset-category/update',
        method: 'put',
        data,
    });
}
// 删除分类
export function deleteCategory(categoryId) {
    return service({
        url: `/lab/asset-category/delete/${categoryId}`,
        method: 'delete',
    });
}
// 绑定资产到分类
export function bindAssets(data) {
    return service({
        url: '/lab/asset-category/bindAssets',
        method: 'post',
        data,
    });
}
// 从分类解绑资产
export function unbindAssets(data) {
    return service({
        url: '/lab/asset-category/unbindAssets',
        method: 'post',
        data,
    });
}
export function getInstrumentByScope(params) {
    return service({
        url: '/lab/asset-category/getInstrumentByScope',
        method: 'get',
        params
    });
}
export function getInstrumentByCustom(params) {
    return service({
        url: '/lab/asset-category/getInstrumentByCustom',
        method: 'get',
        params
    });
}
export function getLabInstrumentSearch(data) {
    return service({
        url: '/labInstruments/search',
        method: 'post',
        data
    });
}
export function searchReservationInstrument(data) {
    return service({
        url: '/labInstruments/searchReservationInstrument',
        method: 'post',
        data
    });
}
export function getInstrumentDetail(params) {
    return service({
        url: '/labInstruments/detail',
        method: 'get',
        params
    });
}
export function getSummaryReport() {
    return service({
        url: '/labInstruments/summaryReport',
        method: 'get'
    });
}
export function updateInstrumentReservable(data) {
    return service({
        url: '/lab/asset-category/updateInstrumentReservable',
        method: 'post',
        data
    });
}
